import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{class:_vm.ticketColor(_vm.public),attrs:{"px-0":"","py-0":"","my-4":""}},[_c(VRow,{staticClass:"xp-comment-header",attrs:{"no-gutters":""}},[_c(VCol,[_vm._v(_vm._s(_vm.author))]),_c(VCol,{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])],1),_c(VRow,{staticClass:"pa-2",attrs:{"no-gutters":""}},[_c(VCol,[_c('p',{staticClass:"tw-font-normal",domProps:{"innerHTML":_vm._s(_vm.body)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }